// extracted by mini-css-extract-plugin
var _1 = "MobileDetailProduct_buttonWrapper__TwWqN";
var _2 = "MobileDetailProduct_container__g84mQ";
var _3 = "MobileDetailProduct_icon__e9CIC fa fa-chevron-left";
export { _1 as "buttonWrapper", _2 as "container", _3 as "icon" }
